import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RegisterFormTW } from '../../components/auth/RegisterFormTW';
import { useLenis } from '../../hooks/useLenis';

export const RegisterPageTW: React.FC = () => {
  useLenis(); // Smooth scrolling aktivieren

  const navigate = useNavigate();

  return (
    <RegisterFormTW
      onSwitchToLogin={() => navigate('/login')}
    />
  );
};

export default RegisterPageTW;
